/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeEvacuationDto } from '../models/type-evacuation-dto';


/**
 * Fonctions de gestion des types d'évacuations
 */
@Injectable({
  providedIn: 'root',
})
export class TypesEvacuationsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeEvacuationGetList
   */
  static readonly TypeEvacuationGetListPath = '/api/types-evacuations/list';

  /**
   * Renvoie la liste des types d'évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationGetList(params?: {
  }): Observable<Array<TypeEvacuationDto>> {

    return this.typeEvacuationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeEvacuationDto>>) => r.body as Array<TypeEvacuationDto>)
    );
  }

  /**
   * Path part for operation typeEvacuationLoadList
   */
  static readonly TypeEvacuationLoadListPath = '/api/types-evacuations/load-list';

  /**
   * Renvoie la liste des types d'évacuations (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeEvacuationLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'évacuations (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeEvacuationLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeEvacuationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeEvacuationGet
   */
  static readonly TypeEvacuationGetPath = '/api/types-evacuations/{id}';

  /**
   * Renvoie le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationGet$Response(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationGet(params: {

    /**
     * Identifiant du type d&#x27;évacuation
     */
    id: number;
  }): Observable<TypeEvacuationDto> {

    return this.typeEvacuationGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeEvacuationDto>) => r.body as TypeEvacuationDto)
    );
  }

  /**
   * Path part for operation typeEvacuationPut
   */
  static readonly TypeEvacuationPutPath = '/api/types-evacuations/{id}';

  /**
   * Met à jour le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeEvacuationPut$Response(params: {

    /**
     * Identifiant du type d&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Type d'évacuation
     */
    body: TypeEvacuationDto
  }): Observable<StrictHttpResponse<TypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeEvacuationDto>;
      })
    );
  }

  /**
   * Met à jour le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeEvacuationPut(params: {

    /**
     * Identifiant du type d&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Type d'évacuation
     */
    body: TypeEvacuationDto
  }): Observable<TypeEvacuationDto> {

    return this.typeEvacuationPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeEvacuationDto>) => r.body as TypeEvacuationDto)
    );
  }

  /**
   * Path part for operation typeEvacuationDelete
   */
  static readonly TypeEvacuationDeletePath = '/api/types-evacuations/{id}';

  /**
   * Supprime le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationDelete$Response(params: {

    /**
     * Identifiant du type d&#x27;évacuation à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationDelete(params: {

    /**
     * Identifiant du type d&#x27;évacuation à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeEvacuationDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeEvacuationPost
   */
  static readonly TypeEvacuationPostPath = '/api/types-evacuations';

  /**
   * Crée le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeEvacuationPost$Response(params: {

    /**
     * Type d'évacuation
     */
    body: TypeEvacuationDto
  }): Observable<StrictHttpResponse<TypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeEvacuationDto>;
      })
    );
  }

  /**
   * Crée le type d'évacuation spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeEvacuationPost(params: {

    /**
     * Type d'évacuation
     */
    body: TypeEvacuationDto
  }): Observable<TypeEvacuationDto> {

    return this.typeEvacuationPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeEvacuationDto>) => r.body as TypeEvacuationDto)
    );
  }

  /**
   * Path part for operation typeEvacuationGetByReference
   */
  static readonly TypeEvacuationGetByReferencePath = '/api/types-evacuations/reference/{reference}';

  /**
   * Renvoie le type d'évacuation recherché par référence.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeEvacuationGetByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationGetByReference$Response(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<StrictHttpResponse<TypeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesEvacuationsService.TypeEvacuationGetByReferencePath, 'get');
    if (params) {
      rb.path('reference', params.reference, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie le type d'évacuation recherché par référence.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeEvacuationGetByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeEvacuationGetByReference(params: {

    /**
     * Référence
     */
    reference: string;
  }): Observable<TypeEvacuationDto> {

    return this.typeEvacuationGetByReference$Response(params).pipe(
      map((r: StrictHttpResponse<TypeEvacuationDto>) => r.body as TypeEvacuationDto)
    );
  }

}
